export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VideoModal.vue?vue&type=template&id=126722ce&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/VideoModal.vue?vue&type=template&id=126722ce&scoped=true&
// module id = 234
// module chunks = 0